module.exports = __webpack_public_path__ + "fonts/MessinaSansWeb-RegularItalic.b4e3fd5d.eot";